import {changeFieldProperty, setFieldEdition, setFieldVisibility} from "../../../../../apps/KpModule/actions"
import moment from "moment"

export const module_ = {
    object: 'LiberalityAdvance',
    name: 'LiberalityAdvance',
    tKey: 'Avance sur legs',
    category: {
        path: 'menuTitle_liberalities',
        icon: 'testament'
    },
    defaultSortBy: 'updatedAt',
    defaultSortDirection: 'DESC',
    viewMap: {
        dt: [
            {path: 'beneficiary', tKey: 'Bénéficiaire', display: 'zipCodeAndName'},
            {path: 'acceptedSolicitationsCount', tKey: 'Nombre', initiallyNotVisible: true, tooltip: true},
            {path: 'grantedTotal', tKey: 'Accordé (€)', tooltip: true},
            {path: 'paidTotal', tKey: 'Versé (€)', tooltip: true},
            {path: 'imputedTotal', tKey: 'Imputé (€)', tooltip: true},
            {path: 'balance', tKey: 'Solde (€)', tooltip: true},
            {path: 'lastPaymentDate', tKey: 'Dernier versement le', initiallyNotVisible: true},
            {path: 'updatedBy', tKey: 'MAJ par'},
            {path: 'updatedAt', tKey: 'MAJ le'},
            {path: 'noDeleteButtonAccess', hidden: true},
        ],
        form: {
            fields: [
                {
                    path: 'beneficiary',
                    tKey: 'Bénéficiaire',
                    display: 'zipCodeAndName',
                    required: true,
                    editable: false,
                    filters: ['isMemberAssociation'],
                    fieldPath: [
                        'id', 'zipCodeAndName',
                        'advanceRecoveryImputations.id',
                        'advanceRecoveryImputations.date',
                        'advanceRecoveryImputations.advanceRecoveryAmount',
                        'advanceRecoveryImputations.comment',
                        'advanceRecoveryImputations.asset.identifier',
                        'advanceRecoveryImputations.asset.applicationNumber',
                        'advanceRecoveryImputations.asset.typeOfFile',
                        'liberalityBeneficiaryFiles.id',
                        'liberalityBeneficiaryFiles.assetInfos.liberalityRecord.applicationNumber',
                        'liberalityBeneficiaryFiles.assetInfos.liberalityRecord.status.id',
                        'liberalityBeneficiaryFiles.assetInfos.liberalityRecord.status.name',
                        'liberalityBeneficiaryFiles.assetInfos.liberalityRecord.status.bStyle',
                        'liberalityBeneficiaryFiles.assetInfos.liberalityRecord.decisionDate',
                        'liberalityBeneficiaryFiles.assetInfos.liberalityRecord.administrator.id',
                        'liberalityBeneficiaryFiles.assetInfos.liberalityRecord.administrator.fullName',
                        'liberalityBeneficiaryFiles.assetInfos.liberalityRecord.typeOfFile.id',
                        'liberalityBeneficiaryFiles.assetInfos.liberalityRecord.typeOfFile.name',
                        'liberalityBeneficiaryFiles.assetInfos.identifier',
                        'liberalityBeneficiaryFiles.estimatedBeneficiaryNetValue',
                        'liberalityBeneficiaryFiles.CNDAShareInEstimatedBeneficiaryNetValue',
                        'liberalityBeneficiaryFiles.assetInfos.status.id',
                        'liberalityBeneficiaryFiles.assetInfos.status.name',
                    ],
                    subscriptions: {
                        onChange: (newValue, oldValue, {store, module}) => {
                            const imputationsField = module.viewMap.form.fields.find(f => f.path === 'imputations')
                            imputationsField.setValue(newValue?.advanceRecoveryImputations || [])
                            store.dispatch(setFieldVisibility(imputationsField.id, !!newValue))

                            const beneficiaryFilesField = module.viewMap.form.fields.find(f => f.path === 'beneficiaryFiles')
                            beneficiaryFilesField.setValue(newValue?.liberalityBeneficiaryFiles || [])
                            store.dispatch(setFieldVisibility(beneficiaryFilesField.id, !!newValue))
                        }
                    }
                },
                {
                    path: 'beneficiaryFiles',
                    type: 'accordion',
                    tKey: 'Suivi des dossiers du bénéficiaire',
                    newable: false,
                    removable: false,
                    disabled: true,
                    defaultSortBy: 'assetInfos.liberalityRecord.applicationNumber',
                    defaultSortDirection: 'ASC',
                    viewMap: {
                        dt: [
                            {path: 'assetInfos.liberalityRecord.applicationNumber', tKey: 'N° dossier'},
                            {path: 'assetInfos.liberalityRecord.status', tKey: 'Statut dossier', type: 'status', display: 'name', fieldPath: ['id', 'name', 'bStyle'], initiallyNotVisible: true},
                            {path: 'assetInfos.liberalityRecord.decisionDate', tKey: 'Date décision', type: 'dateString', dateFormat: 'YYYY-MM-DD hh:mm', initiallyNotVisible: true},
                            {path: 'assetInfos.liberalityRecord.administrator.fullName', tKey: 'Gestionnaire', initiallyNotVisible: true},
                            {path: 'assetInfos.liberalityRecord.typeOfFile.name', tKey: 'Nature'},
                            {path: 'assetInfos.identifier', tKey: 'Bien'},
                            {path: 'estimatedBeneficiaryNetValue', tKey: 'Net (€)', type: 'number', numberOfDecimals: 2, tooltip: true},
                            {path: 'CNDAShareInEstimatedBeneficiaryNetValue', tKey: 'dont par CNDA (€)', initiallyNotVisible: true, tooltip: true},
                            {path: 'assetInfos.status', tKey: 'Statut bien', display: 'name', type: 'object'},
                        ]
                    }
                },
                {
                    path: 'solicitations',
                    tKey: 'Suivi des sollicitations',
                    removable: false,
                    defaultSortBy: 'requestDate',
                    defaultSortDirection: 'DESC',
                    viewMap: {
                        dt: [
                            {path: 'requestedAmount', tKey: 'Sollicité (€)', tooltip: true},
                            {path: 'requestDate', tKey: 'Date sollicitation', initiallyNotVisible: true},
                            {path: 'status', tKey: 'Statut', display: 'name'},
                            {path: 'decisionBody', tKey: 'Organe de décision', display: 'name', initiallyNotVisible: true},
                            {path: 'decisionDate', tKey: 'Date décision', initiallyNotVisible: true},
                            {path: 'grantedAmount', tKey: 'Accordé (€)', tooltip: true},
                            {path: 'paymentDate', tKey: 'Date versement'},
                        ],
                        form: [
                            {
                                path: 'requestedAmount',
                                tKey: 'Sollicité (€)',
                                required: true,
                                minValue: 0,
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module}) => {
                                        const solicitationsField = module.viewMap.form.fields.find(f => f.path === 'solicitations')
                                        const grantedAmountField = solicitationsField.viewMap.form.fields.find(f => f.path === 'grantedAmount')
                                        store.dispatch(changeFieldProperty(grantedAmountField.id, 'maxValue', newValue))
                                    }
                                }
                            },
                            {
                                path: 'requestDate',
                                tKey: 'Date sollicitation',
                                required: true,
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                            },
                            {path: 'description', tKey: 'Description', type: 'richTextEditor'},
                            {
                                path: 'status',
                                tKey: 'Statut',
                                display: 'name',
                                required: true,
                                sortList: false,
                                default: {id: 'proposed', name: 'Proposé'},
                                widthClassName: 'col-xs-12 col-sm-6',
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module, formInitialize}) => {
                                        const solicitationsField = module.viewMap.form.fields.find(f => f.path === 'solicitations')
                                        const requestedAmountField = solicitationsField.viewMap.form.fields.find(f => f.path === 'requestedAmount')
                                        const requestDateField = solicitationsField.viewMap.form.fields.find(f => f.path === 'requestDate')
                                        const descriptionField = solicitationsField.viewMap.form.fields.find(f => f.path === 'description')
                                        const statusField = solicitationsField.viewMap.form.fields.find(f => f.path === 'status')
                                        const decisionBodyField = solicitationsField.viewMap.form.fields.find(f => f.path === 'decisionBody')
                                        const decisionDateField = solicitationsField.viewMap.form.fields.find(f => f.path === 'decisionDate')
                                        const grantedAmountField = solicitationsField.viewMap.form.fields.find(f => f.path === 'grantedAmount')
                                        const paymentDateField = solicitationsField.viewMap.form.fields.find(f => f.path === 'paymentDate')

                                        const isProposed = newValue?.id === 'proposed'
                                        const isAccepted = newValue?.id === 'accepted'

                                        store.dispatch(setFieldVisibility(decisionBodyField.id, !isProposed))
                                        store.dispatch(changeFieldProperty(decisionBodyField.id, 'required', !isProposed))
                                        store.dispatch(setFieldVisibility(decisionDateField.id, !isProposed))
                                        store.dispatch(changeFieldProperty(decisionDateField.id, 'required', !isProposed))
                                        store.dispatch(setFieldVisibility(grantedAmountField.id, isAccepted))
                                        store.dispatch(changeFieldProperty(grantedAmountField.id, 'required', isAccepted))

                                        if (!formInitialize && !isAccepted) {
                                            grantedAmountField.setValue(0)
                                        }

                                        const grantedAmount = grantedAmountField.getValue()
                                        store.dispatch(setFieldVisibility(paymentDateField.id, isAccepted && grantedAmount > 0))
                                        store.dispatch(changeFieldProperty(paymentDateField.id, 'required', isAccepted && grantedAmount > 0))

                                        if (formInitialize) {
                                            store.dispatch(changeFieldProperty(requestedAmountField.id, 'editable', isProposed))
                                            store.dispatch(changeFieldProperty(requestDateField.id, 'editable', isProposed))
                                            store.dispatch(changeFieldProperty(descriptionField.id, 'editable', isProposed))
                                            store.dispatch(changeFieldProperty(statusField.id, 'editable', isProposed))
                                        }
                                    }
                                }
                            },
                            {
                                path: 'decisionBody',
                                tKey: 'Organe de décision',
                                display: 'name',
                                widthClassName: 'col-xs-12 col-sm-6',
                                hidden: true,
                            },
                            {
                                path: 'decisionDate',
                                tKey: 'Date décision',
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                                hidden: true,
                            },
                            {
                                path: 'grantedAmount',
                                tKey: 'Accordé (€)',
                                default: 0,
                                minValue: 0,
                                widthClassName: 'col-xs-12 col-sm-6',
                                hidden: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module, formInitialize}) => {
                                        const solicitationsField = module.viewMap.form.fields.find(f => f.path === 'solicitations')
                                        const statusField = solicitationsField.viewMap.form.fields.find(f => f.path === 'status')
                                        const paymentDateField = solicitationsField.viewMap.form.fields.find(f => f.path === 'paymentDate')

                                        const isAccepted = statusField.getValue()?.id === 'accepted'
                                        store.dispatch(setFieldVisibility(paymentDateField.id, isAccepted && newValue > 0))
                                        store.dispatch(changeFieldProperty(paymentDateField.id, 'required', isAccepted && newValue > 0))
                                    }
                                }
                            },
                            {
                                path: 'paymentDate',
                                tKey: 'Date de versement',
                                endDate: moment().format('YYYY-MM-DD'),
                                widthClassName: 'col-xs-12 col-sm-6',
                                hidden: true,
                                subscriptions: {
                                    onChange: (newValue, oldValue, {store, module, formInitialize}) => {
                                        if (!formInitialize) return

                                        const solicitationsField = module.viewMap.form.fields.find(f => f.path === 'solicitations')
                                        const decisionBodyField = solicitationsField.viewMap.form.fields.find(f => f.path === 'decisionBody')
                                        const decisionDateField = solicitationsField.viewMap.form.fields.find(f => f.path === 'decisionDate')
                                        const grantedAmountField = solicitationsField.viewMap.form.fields.find(f => f.path === 'grantedAmount')
                                        const paymentDateField = solicitationsField.viewMap.form.fields.find(f => f.path === 'paymentDate')

                                        store.dispatch(changeFieldProperty(decisionBodyField.id, 'editable', !newValue || !decisionBodyField.getValue()))
                                        store.dispatch(changeFieldProperty(decisionDateField.id, 'editable', !newValue || !decisionDateField.getValue()))
                                        store.dispatch(changeFieldProperty(grantedAmountField.id, 'editable', !newValue || !grantedAmountField.getValue()))
                                        store.dispatch(changeFieldProperty(paymentDateField.id, 'editable', !newValue))
                                    }
                                }
                            },
                        ]
                    }
                },
                {
                    path: 'imputations',
                    type: 'accordion',
                    tKey: 'Suivi des imputations',
                    newable: false,
                    removable: false,
                    disabled: true,
                    defaultSortBy: 'date',
                    defaultSortDirection: 'DESC',
                    viewMap: {
                        dt: [
                            {path: 'asset.applicationNumber', tKey: 'N° dossier'},
                            {path: 'asset.typeOfFile', tKey: 'Nature'},
                            {path: 'asset.identifier', tKey: 'Bien'},
                            {path: 'advanceRecoveryAmount', tKey: 'Imputé (€)', type: 'number', numberOfDecimals: 2, tooltip: true},
                            {path: 'date', type: 'dateString', tKey: 'Date imputation'},
                        ],
                        form: [
                            {path: 'asset.applicationNumber', tKey: 'N° dossier', widthClassName: 'col-xs-12 col-sm-6'},
                            {path: 'asset.typeOfFile', tKey: 'Nature', widthClassName: 'col-xs-12 col-sm-6'},
                            {path: 'asset.identifier', tKey: 'Bien', widthClassName: 'col-xs-12 col-sm-6'},
                            {path: 'advanceRecoveryAmount', tKey: 'Imputé (€)', widthClassName: 'col-xs-12 col-sm-6'},
                            {path: 'date', type: 'datePicker', tKey: 'Date imputation', widthClassName: 'col-xs-12 col-sm-6'},
                            {path: 'comment', tKey: 'Commentaire', type: 'richTextEditor'},
                        ]
                    }
                },
                {path: 'conversations', tKey: "zone d'échanges"}
            ],
            onOpen: ({store, module}) => {
                const state = store.getState()
                const objectMode = state.ui.objectMode
                const isNewObject = objectMode === 'newObject'
                const beneficiaryFilesField = module.viewMap.form.fields.find(field => field.path === 'beneficiaryFiles')
                const imputationsField = module.viewMap.form.fields.find(field => field.path === 'imputations')
                store.dispatch(setFieldVisibility(beneficiaryFilesField.id, !isNewObject))
                store.dispatch(setFieldVisibility(imputationsField.id, !isNewObject))
            }
        }
    }
}